import { render, staticRenderFns } from "./p-importer-help.vue?vue&type=template&id=02a8f1b6&"
import script from "./p-importer-help.vue?vue&type=script&lang=js&"
export * from "./p-importer-help.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports